const TEAM_MEMBER_LABEL = {
	juan: "Juan",
	thaiane: "Thaiane",
	rafaela: "Rafaela",
} as const;

export function teamMemberLabel(login: string) {
	return login in TEAM_MEMBER_LABEL
		? TEAM_MEMBER_LABEL[login as keyof typeof TEAM_MEMBER_LABEL]
		: login;
}
